import axios from 'axios';
import testLocalStorage from '../components/testLocalStorage';
import store from './../search/searchStore';

function statHistoryCache() {
    return {
        addEntry: function(idUser, entryUniqueId, entry, bucket, limit) {
            if (testLocalStorage() === false) {
                return;
            }
            this.addUniqueEntry(bucket, limit, idUser, { 'entryUniqueId': entryUniqueId, 'entry': entry });
        },
        deleteEntry: function(idUser, entryUniqueId, bucket) {
            const entries = this.getEntries(bucket);
            if (idUser in entries) {
                for (let i = 0; i < entries[idUser].length; i++) {
                    const obj = entries[idUser][i];
                    for (const key in obj) {
                        if (obj[key].entryUniqueId === entryUniqueId) {
                            entries[idUser].splice(i, 1);
                        }
                    }
                }
            }
            this.setStorage(bucket, entries);
        },
        getHistoryAjax: function(idUser, bucket, path, element, searchList, callback = () => undefined) {
            const entries = this.getEntriesForUser(bucket, idUser);
            axios.post(path, { 'entries': entries, 'searchList': searchList }).then(response => {
                const targetElement = document.querySelector(element);
                if (targetElement) {
                    targetElement.innerHTML = response.data;
                }
            }).finally(() => {
                callback();
            });
        },
        getHistoryDataJson: function(idUser, bucket, path) {
            const entries = this.getEntriesForUser(bucket, idUser);
            axios.post(path, { 'entries': entries }).then(response => {
                store.dispatch('setHistory', response.data);
            });
        },
        addUniqueEntry: function(bucket, limit, idUser, entry) {
            let entries = this.getEntries(bucket);
            entries = this.initEntriesForUser(entries, idUser);
            entries = this.removeDuplicates(idUser, entries, entry);
            entries[idUser].push(this.createTimeStampedEntry(entry));
            entries[idUser] = this.trimToLimit(entries[idUser], limit);

            this.setStorage(bucket, entries);
        },
        trimToLimit: function(entries, limit) {
            if (entries.length <= limit) {
                return entries;
            }

            entries.splice(0, (entries.length - limit));

            return entries;
        },
        removeDuplicates: function(idUser, entries, entry) {
            let duplicateRemoved = false;
            for (let i = 0; i < entries[idUser].length; i++) {
                const obj = entries[idUser][i];
                for (const key in obj) {
                    if (obj[key].entryUniqueId === entry.entryUniqueId) {
                        entries[idUser].splice(i, 1);
                        duplicateRemoved = true;
                    }
                }
            }
            if (duplicateRemoved === true) {
                return this.removeDuplicates(idUser, entries, entry);
            } else {
                return entries;
            }
        },
        getEntriesForUser: function(bucket, idUser) {
            return this.initEntriesForUser(this.getEntries(bucket), idUser);
        },
        createTimeStampedEntry: function(entry) {
            const jsonEntry = {};
            jsonEntry[this.getTimestamp()] = entry;

            return jsonEntry;
        },
        initEntriesForUser: function(entries, idUser) {
            if (entries === null) {
                entries = { 0: 1 };
            }
            if (!Object.prototype.hasOwnProperty.call(entries, idUser)) {
                entries[idUser] = [];
            }

            return entries;
        },

        getEntries: function(bucket) {
            const storageValue = this.getStorage(bucket);
            if (storageValue !== null) {
                return JSON.parse(storageValue);
            } else {
                return null;
            }
        },
        setStorage: function(bucket, value) {
            window.localStorage.setItem(bucket, this.rot(window.btoa(JSON.stringify(value))));
        },
        getStorage: function(bucket) {
            const bucketItem = window.localStorage.getItem(bucket);
            if (bucketItem !== null) {
                return window.atob(this.rot(bucketItem));
            }

            return null;
        },
        getTimestamp: function() {
            let timestamp = 0;

            const date = new Date();
            const n = date.getTimezoneOffset();
            timestamp = +date;
            timestamp = Math.round(timestamp / 1000) - (n * 60);

            return timestamp;
        },
        rot: function(s) {
            return (s ? s : this).split('').map(function(_) {
                if (!_.match(/[A-Za-z]/)) {return _;}
                const c = Math.floor(_.charCodeAt(0) / 97);
                const k = (_.toLowerCase().charCodeAt(0) - 83) % 26 || 26;

                return String.fromCharCode(k + ((c === 0) ? 64 : 96));
            }).join('');
        },
    };
}

const userHistoryCacheDataElement = document.getElementById('user-history');

if (userHistoryCacheDataElement) {
    const userHistoryCache = JSON.parse(userHistoryCacheDataElement.dataset.history);
    const historyCache = statHistoryCache();
    historyCache.addEntry(
        userHistoryCache.userId,
        userHistoryCache.historyEntryId,
        userHistoryCache.historyEntry,
        userHistoryCache.historyType,
        userHistoryCache.historyLimit
    );
}

export { statHistoryCache };
